import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "question" }
const _hoisted_2 = ["src"]

import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { girocode } from "@dipser/epc-qr-code.js";
import Modal from "@/components/Modal.vue";
import { Invoice } from "@/helpers/invoice/typesDefinition";


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentModal',
  props: {
    invoice: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n({
  useScope: "global",
  inheritLocale: true,
});

const qrCode = computed(() => {
  const g = girocode({
    bic: props.invoice.bic,
    name: "26lights SPRL",
    iban: props.invoice.iban,
    currency: "EUR",
    amount: (props.invoice.balance / 100).toFixed(2),
    ref: props.invoice.communication,
  });
  return g.svg_data_url();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
  }, {
    header: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(t)("titles.invoicePayment", { invoiceNumber: __props.invoice.invoiceNumber })), 1)
    ]),
    body: _withCtx(() => [
      (qrCode.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: qrCode.value,
            alt: "EPC Payment QR-Code"
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})